export const LifeChange = {
  'Urinary Issues': 'ur',
  'Bowel Function': 'bi',
  'Sexual Issues': 'si',
  'Hormonal Issues': 'hf',
  Fatigue: 'fa',
  'Physical Wellbeing': 'ex',
  'Overall Mental Wellbeing': 'sa'
};

export const Treatment = {
  Surgery: 'surgery',
  Brachytherapy: 'radiation',
  'External Beam Radiotherapy': 'radiation',
  'Radiotherapy (type unknown)': 'radiation',
  'Androgen Deprivation Therapy Only': 'hormone_therapy',
  'Active Surveillance': 'active_surveillance',
  'Watchful Waiting': 'watchful_waiting',
  Abiraterone: 'advanced_treatments',
  Enzalutamide: 'advanced_treatments',
  'Abiraterone / Enzalutamide': 'advanced_treatments'
};
